<template>
  <Layout v-loading="isLoading">
    <template #top>
      <Head
        :searchConfig="tableData.searchConfig"
        @businessAuthorize="businessAuthorize"
      />
    </template>
    <template>
      <Body :headConfig="tableData.headConfig" :tableData="data" />
    </template>
  </Layout>
</template>

<script>
import getBusiness from "@/api/getBusiness.js";
import Layout from "@/components/Layout";
import Head from "@/components/Table/Head";
import Body from "@/components/Table/Body";
import Foot from "@/components/Table/Foot";
import requstData from "@/mixins/requstData.js";

export default {
  mixins: [requstData([], true)],
  components: {
    Layout,
    Head,
    Body,
    Foot,
  },
  data() {
    return {
      tableData: {
        headConfig: {
          select: false,
          key: "pageId",
          list: [
            { label: "应用名称", prop: "appName", width: "250" },
            { label: "应用ID", prop: "appId", width: "250" },
            { label: "资产ID", prop: "assetId", width: "250" },
            { label: "商务平台ID", prop: "businessId", width: "250" },
            { label: "绑定日期", prop: "createTime" },
          ],
        },
        searchConfig: {
          list: [
            {
              type: "button",
              span: 5,
              operation: [
                {
                  type: 1,
                  label: "+新增business授权",
                  style: "success",
                  listeners: "businessAuthorize",
                },
              ],
            },
          ],
        },
      },
    };
  },
  methods: {
    async requst(params) {
      return await getBusiness();
    },
    businessAuthorize(data) {
      top.location =
        window.location = `https://www.facebook.com/v24.0/dialog/oauth?scope=read_audience_network_insights&client_id=154939337550104&redirect_uri=${
          process.env.NODE_ENV === "development"
            ? "https://localhost:8080"
            : "https://tools.nothingdb.com"
        }/home/authorize/business`;
    },
  },
};
</script>
<style lang="less"></style>
